import { ITranslations } from 'types/common';
import { IsDeletedSelectTransFields } from './types';
import en from 'translations/en/isDeletedSelect.json';
import pl from 'translations/pl/isDeletedSelect.json';
import sl from 'translations/sl/isDeletedSelect.json';

export const isDeletedSelectTranslations: ITranslations<IsDeletedSelectTransFields> = {
  name: 'isDeletedSelect',
  en,
  pl,
  sl,
};
